import * as React from 'react';

import { Responsive, UIHeading1, UIHeading2 } from '@cian/ui-kit';
import * as styles from './PageTitle.css';

export const PageTitle: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return (
    <div className={styles['heading']}>
      <Responsive desktop tablet>
        <UIHeading1 as="h1">{children}</UIHeading1>
      </Responsive>
      <Responsive phone>
        <UIHeading2 as="h1">{children}</UIHeading2>
      </Responsive>
    </div>
  );
};
